import { translate } from '../../util/translate'

export const appointmentHeaders = [
  {
    text: translate['appointment.history.label.code'],
    value: 'code',
    width: '90',
  },
  {
    text: translate['appointment.history.label.type'],
    value: 'type',
    width: '250',
  },
  {
    text: translate['appointment.history.label.realtiesCode'],
    value: 'realtiesCode',
    width: '250',
  },
  {
    text: translate['appointment.history.label.status'],
    value: 'status',
    width: '180',
  },
  {
    text: translate['appointment.history.label.date'],
    value: 'date',
    width: '200',
  },
  {
    text: translate['appointment.history.label.cancelDate'],
    value: 'cancel_date',
    width: '200',
  },
  {
    text: translate['appointment.history.label.workerType'],
    value: 'worker_type',
    width: '200',
  },
  {
    text: translate['appointment.history.label.hostName'],
    value: 'host',
    width: '250',
  },
  { value: 'actions', align: 'end', width: '50' },
]

export const advancedAppointmentHeaders = [
  {
    text: translate['appointment.history.label.code'],
    value: 'code',
    width: '90',
  },
  {
    text: translate['appointment.history.label.type'],
    value: 'type',
    width: '250',
  },
  {
    text: translate['appointment.history.label.realtiesCode'],
    value: 'realtiesCode',
    width: '250',
  },
  {
    text: translate['appointment.history.label.status'],
    value: 'status',
    width: '180',
  },
  {
    text: translate['appointment.history.label.date'],
    value: 'date',
    width: '200',
  },
  {
    text: translate['appointment.history.label.cancelDate'],
    value: 'cancel_date',
    width: '200',
  },
  {
    text: translate['appointment.history.label.groupCode'],
    value: 'group',
    width: '150',
    align: 'center',
  },
  {
    text: translate['appointment.history.label.workerType'],
    value: 'worker_type',
    width: '200',
  },
  {
    text: translate['appointment.history.label.hostName'],
    value: 'host',
    width: '250',
  },
  {
    text: translate['appointment.history.label.customer'],
    value: 'real_estate',
    width: '400',
  },
  {
    text: translate['appointment.history.label.branch'],
    value: 'branch',
    width: '400',
  },
  {
    text: translate['appointment.history.label.observations'],
    value: 'observations',
    width: '400',
  },
  {
    text: translate['appointment.history.label.visitorName'],
    value: 'visitor_name',
    width: '400',
  },
  {
    text: translate['appointment.history.label.visitorPhone'],
    value: 'visitor_phone',
    width: '200',
  },
  {
    text: translate['appointment.history.label.additionalData'],
    value: 'additional_data',
    width: '600',
  },
  {
    text: translate['appointment.history.label.confirmations'],
    value: 'confirmation',
    width: '80',
  },
  { value: 'actions', align: 'end', width: '50' },
]

export const advancedCustomerAppointmentHeaders = [
  {
    text: translate['appointment.history.label.code'],
    value: 'code',
    width: '90',
  },
  {
    text: translate['appointment.history.label.type'],
    value: 'type',
    width: '250',
  },
  {
    text: translate['appointment.history.label.realtiesCode'],
    value: 'realtiesCode',
    width: '250',
  },
  {
    text: translate['appointment.history.label.status'],
    value: 'status',
    width: '180',
  },
  {
    text: translate['appointment.history.label.date'],
    value: 'date',
    width: '200',
  },
  {
    text: translate['appointment.history.label.cancelDate'],
    value: 'cancel_date',
    width: '150',
  },
  {
    text: translate['appointment.history.label.groupCode'],
    value: 'group_code',
    width: '150',
    align: 'center',
  },
  {
    text: translate['appointment.history.label.workerType'],
    value: 'worker_type',
    width: '200',
  },
  {
    text: translate['appointment.history.label.hostName'],
    value: 'host',
    width: '250',
  },
  {
    text: translate['appointment.history.label.branch'],
    value: 'branch',
    width: '200',
  },
  {
    text: translate['appointment.history.label.observations'],
    value: 'observations',
    width: '150',
  },
  {
    text: translate['appointment.history.label.visitorName'],
    value: 'visitor_name',
    width: '150',
  },
  {
    text: translate['appointment.history.label.visitorPhone'],
    value: 'visitor_phone',
    width: '200',
  },
  {
    text: translate['appointment.history.label.additionalData'],
    value: 'additional_data',
    width: '200',
  },
  {
    text: translate['appointment.history.label.confirmations'],
    value: 'confirmation',
    width: '80',
  },
  { value: 'actions', align: 'end', width: '50' },
]

export const selectedMarkersHeaders = [
  {
    text: translate['appointment.history.label.type'],
    value: 'title',
  },
  {
    text: translate['appointment.history.label.date'],
    value: 'date',
    width: '150',
  },
  {
    text: translate['appointment.history.label.status'],
    value: 'status',
    width: '150',
  },
  {
    text: translate['appointment.history.label.confirmations'],
    value: 'confirmation',
    width: '150',
  },
  {
    text: translate['appointment.history.label.group'],
    value: 'group_code',
    width: '50',
  },
  {
    text: '',
    value: 'actions',
    width: '10',
  },
]
